import React from "react";
import ChartForm from "./ChartForm";

const ProblemViewForm = ({
  src,
  clickLock,
  onLoad,
  onClick,
  onFinishClick,
  status,
  progress,
  areaView,
  achieve,
  seqNo,
  name,
  grade,
  domainNames,
  t_type,
}) => {
  return (
    <>
      <div className="wrapper">
        <div className="math-AI-scanning">
          <div className="AI-analysis">
            <header className="analysis-header">
              <h1 className="top-title">AI스캐닝 수학 진단평가</h1>
              {t_type === "reg-mem" && (
                <div className="top-close">
                  <button
                    className="btn-close"
                    onClick={() => {
                      window.handleConfirm();
                    }}
                  >
                    <i className="icon i-top-close">닫기</i>
                  </button>
                </div>
              )}
            </header>
            <aside className="analysis-side">
              <h2 className="side-title">
                <div className="dp-table">
                  <div className="dp-cell">
                    <span className="st-user">{name}</span> 학생의 영역별 <br />
                    적정 수준 이해도 분석
                  </div>
                </div>
              </h2>
              <div className="side-ai-graph">
                <ChartForm
                  achieve={seqNo > 2 ? achieve : null}
                  grade={grade}
                  domainNames={domainNames}
                ></ChartForm>
              </div>
              <div className="side-ai-area">
                <div className="side-ai-area-wrap">
                  <div
                    className={"ai-motion is-motion " + status["status-motion"]}
                  >
                    <span className="i-motion i-motion-analysis"></span>
                  </div>
                  <div className="ai-txt">{status["status-text"]}</div>
                </div>
              </div>
            </aside>
            <div className="analysis-content">
              <div
                className="ai-quiz-area"
                style={clickLock ? { pointerEvents: "none" } : {}}
              >
                <div className="ai-quiz">
                  <iframe
                    title="ai-quiz-iframe"
                    src={src}
                    onLoad={onLoad}
                    frameBorder="0"
                    className="ai-quiz-iframe"
                  ></iframe>
                </div>
              </div>
              {areaView === 0 ? (
                <div className="ai-button-area">
                  <button
                    className="button-bottom button-submit"
                    onClick={onClick}
                  >
                    답안제출
                  </button>
                </div>
              ) : areaView === 1 ? (
                <div className="ai-loading-area">
                  <div className="ai-loading-bar bar2">
                    <span
                      className="loading-current-bar"
                      style={{
                        width: String(progress) + "%",
                        transition: "width 2s linear",
                      }}
                    ></span>
                  </div>
                </div>
              ) : (
                <div className="ai-button-area">
                  <button
                    className="button-bottom button-confirm"
                    onClick={onFinishClick}
                  >
                    결과 리포트 확인하기
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProblemViewForm;
